import { Modal, ModalBody } from "reactstrap";

const instructionsText = 'Por favor ingrese su correo y siga las intrucciones que le envíaremos.';

const RecoverPassModal = (props) => {
  const { open, toggle } = props;
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(e);
  }
  return (
    <Modal isOpen={open} toggle={toggle}>
      <div className='gm-modal-header'>
        <div className='gm-modal-title-container'>
          <div className='gm-modal-title'>Recuperar Contraseña</div>
        </div>
        <button type="button" className="btn-close" aria-label="Close" onClick={toggle} />
      </div>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div className='gm-modal-form-container'>
            <div className='gm-modal-form-section'>
              <div className="gm-invitation-container">
                <div className="gm-invitation-info">{instructionsText}</div>
              </div>
              <div className='gm-modal-form-group gm-wide-group'>
                <div className='gm-modal-input-group '>
                  <label htmlFor="email">Correo</label>
                  <input
                    id='email'
                    name="email"
                    type='email'
                    placeholder="Ingrese su correo"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='gm-modal-buttons'>
            <button type='button' className='gm-secondary-button' onClick={toggle}>
              Cancelar
            </button>
            <button type='submit' className='gm-primary-button'>
              Envíar Código
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}

export default RecoverPassModal;